var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-form-item",
    { attrs: { label: _vm.i18nt("designer.setting.withCredentials") } },
    [
      _c("el-switch", {
        model: {
          value: _vm.optionModel.withCredentials,
          callback: function ($$v) {
            _vm.$set(_vm.optionModel, "withCredentials", $$v)
          },
          expression: "optionModel.withCredentials",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }